<template>
  <a-layout class='index animated fadeIn s_bf'>
    <SmallSquare content='会员标签是对用户会员在平台内行为进行归类管理，可根据管理需要进行自定义标签设置。' :padding='true'></SmallSquare>
    <a-card :bordered="false">
      <div class="m-b-25">
        <span class='mr15'>
          <a-button type="primary" v-has:userTagsAdd="()=> {formData={};type='add';tagsVisible=true}">
            <PlusOutlined />
            添加标签
          </a-button>
        </span>
      </div>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item name='keyword' label='关键词'>
          <a-input style="width: 270px" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
          <a-button class='m-r-10' v-has:userTagExport="exportTable">导出</a-button>

        </a-form-item>
      </a-form>
      <div class='m-t-25'>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
          <template v-slot:tagRule="{ record }">
            <div v-if='record.point == 0 && record.buy_num == 0 && Number(record.buy_money)==0'>
              未设置
            </div>
            <div v-else>
              <p v-show="record.point>0">累计积分达到{{record.point}}</p>
              <p v-show="record.buy_num>0">或累计购买次数达到{{record.buy_num}}</p>
              <p v-show="record.buy_money>0">或累计消费金额达到{{record.buy_money}}</p>
              <p v-show="record.first_scan>0">或累计扫码次数达到{{record.first_scan}}</p>
            </div>
          </template>
          <template v-slot:action="{ record }">
            <a v-has:setUserTags="()=>success(record)" href="javascript:;" class="m-r-15">打标签</a>

            <a v-has:userTagsDetail="()=>{formData=JSON.parse(JSON.stringify(record));type='look';tagsVisible=true;}" href="javascript:;" v-if="record.person>0" class="m-r-15">详情</a>
            <a v-has:userTagsEdit="()=>{formData=JSON.parse(JSON.stringify(record));type='edit';tagsVisible=true;}" href="javascript:;" v-else class="m-r-15">编辑</a>
            <a v-has:userTagsDel="()=>del(record,'edit')" href="javascript:;">删除</a>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
      </div>
    </a-card>
  </a-layout>
  <a-modal :keyboard="false" :title="formData.id?'修改标签':'添加标签'" centered v-model:visible="tagsVisible" :width='700' :footer="null" destroyOnClose>
    <tagAdd :formData='formData' :type="type" @openModal="resetTag"></tagAdd>
  </a-modal>

  <!-- 标签人数 -->
  <a-modal :keyboard="false" title="标签人数" centered v-model:visible="showVisible" :width='700' :footer="null" destroyOnClose>
    <a-form layout='inline' class="m-b-20">
      <a-form-item label='关键词'>
        <a-input style="width: 220px" v-model:value="memberWord" placeholder="请输入会员ID/微信昵称" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit' class='m-r-10' @click="getTagMemberDetail(memberTag_id);">搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='pagination' :loading='listLoading' bordered rowKey='id' :columns='columnsTag' :data-source='tagList' @change="changePagination"></a-table>
  </a-modal>
</template>
<script>
import { DownOutlined } from "@ant-design/icons-vue";
import { message, Modal } from "ant-design-vue";
import { inject, reactive, ref, toRefs, h, onMounted } from "vue";
import {
  getMemberTagList,
  delMemberTag,
  getMemberTag,
  getMemberTagInfo,
  tagMemberDetail,
  postMemberDetaill,
  postMemberTag,
} from "@/api/member";
import { iscode } from "@/utils/app";
import tagAdd from "./userTagCreate.vue";
const def = {
  page: 1,
  limit: 8,
  keyword: "",
};
export default {
  name: "",
  components: { tagAdd },
  setup() {
    const state = reactive({
      listLoading: false,
      total: 0,
      tagsVisible: false, //标签创建 修改
      formData: {},
      showVisible: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      tagList: [],
      memberWord: "",
      searchTag: {
        keyword: "",
        page: 1,
        limit: 10,
      },
      type: "add", //edit look
      memberTag_id: "",
    });

    let data = ref();
    const $Modal = inject("$Modal");
    let columns = [
      {
        title: "标签名",
        dataIndex: "tag_name",
        key: "tag_name",
      },
      {
        title: "人数",
        dataIndex: "person",
        key: "person",
        customRender: ({ record }) => {
          // return record.person || '0'
          return h(
            "div",
            {
              onclick: async function () {
                state.memberTag_id = record.id || "";
                state.memberWord = "";
                state.pagination.current = 1;
                state.pagination.pageSize = 10;
                getTagMemberDetail(record.id);
                state.showVisible = true;
                // let res = await tagMemberDetail(record.id).then(res=>res.data)
                // if(iscode(res)){
                //   state.tagList = res.data.data || [];
                //    state.pagination.total = res.data.total || 0;
                //    state.showVisible = true
                // }else{
                //   message.error(res.msg)
                // }
              },
              style: {
                cursor: "pointer",
              },
            },
            record.person || "0"
          );
        },
      },
      {
        title: "标签",
        dataIndex: "tagRule",
        key: "tagRule",
        slots: { customRender: "tagRule" },
        width:300

      },
      {
        title: "添加时间",
        dataIndex: "create_time",
        key: "create_time",
        width:200
      },
      //  {
      //   title: "执行状态",
      //   dataIndex: "",
      //   key: ""
      // },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];

    const columnsTag = [
      {
        title: "会员ID",
        dataIndex: "id",
      },
      {
        title: "微信昵称",
        dataIndex: "member_name",
        customRender: function ({ record }) {
          return [
            h(
              "img",
              {
                style: {
                  width: "50px",
                  height: "50px",
                  // borderRadius:'100%'
                },
                src: record.headimgurl || require("@/assets/images/normal.png"),
              },
              ""
            ),
            h(
              "span",
              {
                style: {
                  marginLeft: "20px",
                },
              },
              record.member_name || "-"
            ),
          ];
        },
      },
      {
        title: "会员等级",
        dataIndex: "level",
      },
      {
        title: "所属门店",
        dataIndex: "store",
        customRender: function ({ record }) {
          return record.store || "-";
        },
      },
    ];

    const initData = async (values) => {
      state.listLoading = true;
      let res = await getMemberTagList({ ...values }).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      }
      state.listLoading = false;
    };
    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    initData(search.value);
    const changTime = (e) => {
      search.value.sub_start_time = e[0];
      search.value.sub_end_time = e[1];
    };

    // 删除标签
    const del = (e) => {
      $Modal.confirm({
        centered: true,
        content: "删除该标签后无法恢复,确定要删除么",
        onOk: async () => {
          let res = await delMemberTag(e.id).then((res) => res.data);
          if (iscode(res, true)) {
            initData(search.value);
          }
        },
      });
    };
    const exportTable = async () => {
      let res = await getMemberTagList({ ...search.value, excel: 1 }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        window.open(res.data.action);
      }
    };

    //会员标签人数
    const getTagMemberDetail = async function (recordId) {
      let res = await tagMemberDetail({
        page: state.pagination.current,
        limit: state.pagination.pageSize,
        id: recordId,
        keyword: state.memberWord,
      }).then((res) => res.data);
      if (iscode(res)) {
        state.tagList = res.data.data || [];
        console.log(state.tagList, "11");
        state.pagination.total = res.data.total || 0;
        state.showVisible = true;
      } else {
        message.error(res.msg);
      }
    };

    //标签人数分页
    const changePagination = function (e) {
      state.pagination.current = e.current;
      getTagMemberDetail(state.memberTag_id);
    };

    const success = function (record) {
      Modal.confirm({
        title: "提示",
        content: h(
          "div",
          {
            style: {
              paddingTop: "10px",
            },
          },
          "确定执行打标签，完成后可点击标签人数查看详情?"
        ),
        async onOk() {
          const hide = message.loading("正在加载中...", 0);
          let res = await postMemberTag({ id: record.id }).then(
            (res) => res.data
          );
          if (iscode(res)) {
            message.success(res.msg);
            await initData(search.value);
            setTimeout(hide);
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        },
      });
    };

    //关闭刷新
    const resetTag = function (bool) {
      state.tagsVisible = bool;
      //列表
      initData(search.value);
    };

    onMounted(() => {});
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      exportTable,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      changTime,
      del,
      columnsTag,
      success,
      resetTag,
      getTagMemberDetail,
      initData,
      changePagination,
    };
  },
};
</script>